"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORTS_URL_PREFIX = void 0;
exports.EXPORTS_URL_PREFIX = '/reports-exports/reports';
